export const normalizeListingResult = (result) => {
  const items =
    Array.isArray(result) ? result.slice() :
    Array.isArray(result?.items) ? result.items.slice() :
    [];

  items.total = Number.isFinite(result?.total) ? result.total : items.length;
  items.page = Number.isFinite(result?.page) ? result.page : 1;
  items.pageSize = Number.isFinite(result?.pageSize) ? result.pageSize : items.length || 1;
  items.pageCount = Number.isFinite(result?.pageCount) ? result.pageCount : 1;
  items.hasNext = Boolean(result?.hasNext);
  items.hasPrev = Boolean(result?.hasPrev);
  items.truncated = Boolean(result?.truncated);
  items.limit = Number.isFinite(result?.limit) ? result.limit : items.length;

  return items;
};

export const cloneListingResult = (result) => normalizeListingResult(result);

export const filterListingResult = (result, predicate) => {
  const filtered = normalizeListingResult(result).filter(predicate);
  filtered.total = Number.isFinite(result?.total) ? result.total : filtered.length;
  filtered.page = Number.isFinite(result?.page) ? result.page : 1;
  filtered.pageSize = Number.isFinite(result?.pageSize) ? result.pageSize : filtered.length || 1;
  filtered.pageCount = Number.isFinite(result?.pageCount) ? result.pageCount : 1;
  filtered.hasNext = Boolean(result?.hasNext);
  filtered.hasPrev = Boolean(result?.hasPrev);
  filtered.truncated = Boolean(result?.truncated);
  filtered.limit = Number.isFinite(result?.limit) ? result.limit : filtered.length;
  return filtered;
};
